<template>
  <h1>L'IMPOSTEUR</h1>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
